import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  // Check if the token exists in localStorage
  const token = localStorage.getItem("token");

  // If no token, redirect to the login page
  if (!token) {
    return <Navigate to="/login" />;
  }

  // If a token exists, render the protected component
  return children;
};

export default ProtectedRoute;
